export default __webpack_public_path__ + "static/Plots0036-5070ddf2f37f3202944d0c3463a010e6.jpg";